module.exports = __webpack_public_path__ + "static/img/commodity_sing06.6c9505e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/malls/commodity_sing06.png
// module id = nkx6
// module chunks = 174